var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnglishCourse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "gridItem__media",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 1600,
    height: 1200,
    viewBox: "0 0 1600 1200",
    style: {
      baselineShift: 0,
      clipRule: "nonzero",
      color: "rgb(61, 61, 61)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      cursor: "auto",
      direction: "ltr",
      display: "block",
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      font: "400 16px / 18.4px Lato, sans-serif",
      imageRendering: "auto",
      letterSpacing: "normal",
      marker: "none",
      overflow: "hidden",
      paintOrder: "normal",
      pointerEvents: "auto",
      shapeRendering: "auto",
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      textAnchor: "start",
      textDecoration: "none solid rgb(61, 61, 61)",
      textRendering: "auto",
      visibility: "visible",
      wordSpacing: 0,
      writingMode: "horizontal-tb"
    },
    fill: "none",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M207.479 1087.28L160.119 506.761C158.918 491.979 163.028 477.254 171.709 465.231L408.009 138.231C414.321 129.475 422.801 122.511 432.617 118.022C442.433 113.532 453.247 111.671 463.999 112.621L1273 183.951C1285.8 185.079 1297.94 190.142 1307.75 198.444C1317.56 206.746 1324.57 217.881 1327.8 230.321L1438.94 658.091C1441.66 668.592 1441.6 679.624 1438.74 690.091L1329.98 1088.68L207.479 1087.28Z",
    fill: "#F4F4F4",
    style: {
      baselineShift: 0,
      fill: "rgb(244, 244, 244)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1141 298.881H378.031V870.001H1141V298.881Z",
    fill: "white",
    stroke: "#B2B6BB",
    strokeWidth: 1.94,
    strokeMiterlimit: 10,
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      stroke: "rgb(178, 182, 187)",
      strokeMiterlimit: 10,
      strokeWidth: "1.94px",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1140.58 298.66H377.5V350.99H1140.58V298.66Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M907.601 386.449H414.641V744.349H907.601V386.449Z",
    fill: "#DADDDF",
    style: {
      baselineShift: 0,
      fill: "rgb(218, 221, 223)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.118 602.12C681.398 602.12 697.838 585.68 697.838 565.4C697.838 545.12 681.398 528.68 661.118 528.68C640.839 528.68 624.398 545.12 624.398 565.4C624.398 585.68 640.839 602.12 661.118 602.12Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.659 566.401L652.27 552.891V579.901L675.659 566.401Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.31 388H932.281V463.03H1115.31V388Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1115.31 388H932.281V463.03H1115.31V388Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.2 400.369H944.238V450.659H1010.2V400.369Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1100.06 405.049H1023.39C1023.24 405.083 1023.09 405.083 1022.95 405.049C1022.8 405.016 1022.66 404.95 1022.54 404.856C1022.43 404.762 1022.33 404.643 1022.27 404.508C1022.2 404.373 1022.17 404.224 1022.17 404.074C1022.17 403.924 1022.2 403.776 1022.27 403.64C1022.33 403.505 1022.43 403.386 1022.54 403.292C1022.66 403.199 1022.8 403.133 1022.95 403.099C1023.09 403.066 1023.24 403.066 1023.39 403.099H1100.06C1100.21 403.066 1100.36 403.066 1100.51 403.099C1100.65 403.133 1100.79 403.199 1100.91 403.292C1101.02 403.386 1101.12 403.505 1101.18 403.64C1101.25 403.776 1101.28 403.924 1101.28 404.074C1101.28 404.224 1101.25 404.373 1101.18 404.508C1101.12 404.643 1101.02 404.762 1100.91 404.856C1100.79 404.95 1100.65 405.016 1100.51 405.049C1100.36 405.083 1100.21 405.083 1100.06 405.049Z",
    fill: "#F4F4F4",
    style: {
      baselineShift: 0,
      fill: "rgb(244, 244, 244)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1100.48 418.25H1023.8C1023.54 418.25 1023.28 418.145 1023.09 417.957C1022.91 417.77 1022.8 417.515 1022.8 417.25C1022.8 416.985 1022.91 416.73 1023.09 416.543C1023.28 416.355 1023.54 416.25 1023.8 416.25H1100.48C1100.75 416.25 1101 416.355 1101.19 416.543C1101.38 416.73 1101.48 416.985 1101.48 417.25C1101.48 417.515 1101.38 417.77 1101.19 417.957C1101 418.145 1100.75 418.25 1100.48 418.25Z",
    fill: "#F4F4F4",
    style: {
      baselineShift: 0,
      fill: "rgb(244, 244, 244)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1067.5 431.439H1023.8C1023.54 431.439 1023.28 431.334 1023.09 431.147C1022.91 430.959 1022.8 430.705 1022.8 430.439C1022.8 430.174 1022.91 429.92 1023.09 429.732C1023.28 429.545 1023.54 429.439 1023.8 429.439H1067.5C1067.77 429.439 1068.02 429.545 1068.21 429.732C1068.4 429.92 1068.5 430.174 1068.5 430.439C1068.5 430.705 1068.4 430.959 1068.21 431.147C1068.02 431.334 1067.77 431.439 1067.5 431.439Z",
    fill: "#F4F4F4",
    style: {
      baselineShift: 0,
      fill: "rgb(244, 244, 244)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974 405.52H980.469L997.94 445.52H990.57L986.57 435.93H967.75L963.659 445.52H956.52L974 405.52ZM984 429.74L977.13 413.86L970.33 429.74H984Z",
    fill: "#DADDDF",
    style: {
      baselineShift: 0,
      fill: "rgb(218, 221, 223)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.31 488.6H932.281V563.63H1115.31V488.6Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1115.31 488.6H932.281V563.63H1115.31V488.6Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.2 500.971H944.238V551.261H1010.2V500.971Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1100.06 505.66H1023.39C1023.13 505.66 1022.87 505.555 1022.68 505.367C1022.5 505.18 1022.39 504.925 1022.39 504.66C1022.39 504.395 1022.5 504.141 1022.68 503.953C1022.87 503.765 1023.13 503.66 1023.39 503.66H1100.06C1100.33 503.66 1100.58 503.765 1100.77 503.953C1100.96 504.141 1101.06 504.395 1101.06 504.66C1101.06 504.925 1100.96 505.18 1100.77 505.367C1100.58 505.555 1100.33 505.66 1100.06 505.66Z",
    fill: "#F4F4F4",
    style: {
      baselineShift: 0,
      fill: "rgb(244, 244, 244)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1100.48 518.85H1023.8C1023.54 518.85 1023.28 518.744 1023.09 518.557C1022.91 518.369 1022.8 518.115 1022.8 517.85C1022.8 517.584 1022.91 517.33 1023.09 517.143C1023.28 516.955 1023.54 516.85 1023.8 516.85H1100.48C1100.75 516.85 1101 516.955 1101.19 517.143C1101.38 517.33 1101.48 517.584 1101.48 517.85C1101.48 518.115 1101.38 518.369 1101.19 518.557C1101 518.744 1100.75 518.85 1100.48 518.85Z",
    fill: "#F4F4F4",
    style: {
      baselineShift: 0,
      fill: "rgb(244, 244, 244)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1067.5 532H1023.8C1023.65 532.034 1023.5 532.034 1023.36 532C1023.21 531.967 1023.07 531.901 1022.95 531.807C1022.84 531.713 1022.74 531.595 1022.68 531.459C1022.61 531.324 1022.58 531.176 1022.58 531.025C1022.58 530.875 1022.61 530.727 1022.68 530.592C1022.74 530.456 1022.84 530.337 1022.95 530.244C1023.07 530.15 1023.21 530.084 1023.36 530.051C1023.5 530.017 1023.65 530.017 1023.8 530.05H1067.5C1067.72 530.101 1067.92 530.225 1068.06 530.402C1068.2 530.579 1068.28 530.799 1068.28 531.025C1068.28 531.252 1068.2 531.472 1068.06 531.649C1067.92 531.826 1067.72 531.95 1067.5 532Z",
    fill: "#F4F4F4",
    style: {
      baselineShift: 0,
      fill: "rgb(244, 244, 244)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974 506.119H980.469L997.94 546.119H990.57L986.57 536.529H967.75L963.659 546.119H956.52L974 506.119ZM984 530.339L977.13 514.459L970.33 530.339H984Z",
    fill: "#DADDDF",
    style: {
      baselineShift: 0,
      fill: "rgb(218, 221, 223)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.31 589.211H932.281V664.241H1115.31V589.211Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1115.31 589.211H932.281V664.241H1115.31V589.211Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.2 601.57H944.238V651.86H1010.2V601.57Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1100.06 606.26H1023.39C1023.13 606.26 1022.87 606.154 1022.68 605.967C1022.5 605.779 1022.39 605.525 1022.39 605.26C1022.39 604.995 1022.5 604.74 1022.68 604.553C1022.87 604.365 1023.13 604.26 1023.39 604.26H1100.06C1100.33 604.26 1100.58 604.365 1100.77 604.553C1100.96 604.74 1101.06 604.995 1101.06 605.26C1101.06 605.525 1100.96 605.779 1100.77 605.967C1100.58 606.154 1100.33 606.26 1100.06 606.26Z",
    fill: "#F4F4F4",
    style: {
      baselineShift: 0,
      fill: "rgb(244, 244, 244)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1100.48 619.449H1023.8C1023.54 619.449 1023.28 619.344 1023.09 619.156C1022.91 618.969 1022.8 618.714 1022.8 618.449C1022.8 618.184 1022.91 617.93 1023.09 617.742C1023.28 617.555 1023.54 617.449 1023.8 617.449H1100.48C1100.75 617.449 1101 617.555 1101.19 617.742C1101.38 617.93 1101.48 618.184 1101.48 618.449C1101.48 618.714 1101.38 618.969 1101.19 619.156C1101 619.344 1100.75 619.449 1100.48 619.449Z",
    fill: "#F4F4F4",
    style: {
      baselineShift: 0,
      fill: "rgb(244, 244, 244)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1067.5 632.639H1023.8C1023.65 632.672 1023.5 632.672 1023.36 632.639C1023.21 632.605 1023.07 632.539 1022.95 632.446C1022.84 632.352 1022.74 632.233 1022.68 632.098C1022.61 631.963 1022.58 631.814 1022.58 631.664C1022.58 631.514 1022.61 631.366 1022.68 631.23C1022.74 631.095 1022.84 630.976 1022.95 630.882C1023.07 630.789 1023.21 630.723 1023.36 630.689C1023.5 630.656 1023.65 630.656 1023.8 630.689H1067.5C1067.72 630.739 1067.92 630.863 1068.06 631.04C1068.2 631.218 1068.28 631.437 1068.28 631.664C1068.28 631.891 1068.2 632.111 1068.06 632.288C1067.92 632.465 1067.72 632.589 1067.5 632.639Z",
    fill: "#F4F4F4",
    style: {
      baselineShift: 0,
      fill: "rgb(244, 244, 244)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974 606.73H980.469L997.94 646.73H990.57L986.57 637.151H967.75L963.659 646.73H956.52L974 606.73ZM984 631L977.13 615.12L970.299 631H984Z",
    fill: "#DADDDF",
    style: {
      baselineShift: 0,
      fill: "rgb(218, 221, 223)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.31 689.811H932.281V764.841H1115.31V689.811Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1115.31 689.811H932.281V764.841H1115.31V689.811Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.2 702.18H944.238V752.47H1010.2V702.18Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1100.06 706.869H1023.39C1023.13 706.869 1022.87 706.764 1022.68 706.576C1022.5 706.389 1022.39 706.134 1022.39 705.869C1022.39 705.604 1022.5 705.35 1022.68 705.162C1022.87 704.975 1023.13 704.869 1023.39 704.869H1100.06C1100.33 704.869 1100.58 704.975 1100.77 705.162C1100.96 705.35 1101.06 705.604 1101.06 705.869C1101.06 706.134 1100.96 706.389 1100.77 706.576C1100.58 706.764 1100.33 706.869 1100.06 706.869Z",
    fill: "#F4F4F4",
    style: {
      baselineShift: 0,
      fill: "rgb(244, 244, 244)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1100.48 720.061H1023.8C1023.54 720.061 1023.28 719.955 1023.09 719.768C1022.91 719.58 1022.8 719.326 1022.8 719.061C1022.8 718.795 1022.91 718.541 1023.09 718.353C1023.28 718.166 1023.54 718.061 1023.8 718.061H1100.48C1100.75 718.061 1101 718.166 1101.19 718.353C1101.38 718.541 1101.48 718.795 1101.48 719.061C1101.48 719.326 1101.38 719.58 1101.19 719.768C1101 719.955 1100.75 720.061 1100.48 720.061Z",
    fill: "#F4F4F4",
    style: {
      baselineShift: 0,
      fill: "rgb(244, 244, 244)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1067.5 733.25H1023.8C1023.54 733.25 1023.28 733.145 1023.09 732.957C1022.91 732.77 1022.8 732.515 1022.8 732.25C1022.8 731.985 1022.91 731.73 1023.09 731.543C1023.28 731.355 1023.54 731.25 1023.8 731.25H1067.5C1067.77 731.25 1068.02 731.355 1068.21 731.543C1068.4 731.73 1068.5 731.985 1068.5 732.25C1068.5 732.515 1068.4 732.77 1068.21 732.957C1068.02 733.145 1067.77 733.25 1067.5 733.25Z",
    fill: "#F4F4F4",
    style: {
      baselineShift: 0,
      fill: "rgb(244, 244, 244)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974 707.33H980.469L997.94 747.33H990.57L986.57 737.74H967.75L963.659 747.33H956.52L974 707.33ZM984 731.55L977.13 715.67L970.33 731.55H984Z",
    fill: "#DADDDF",
    style: {
      baselineShift: 0,
      fill: "rgb(218, 221, 223)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.549 839.539C470.918 839.539 485.809 824.649 485.809 806.28C485.809 787.911 470.918 773.02 452.549 773.02C434.18 773.02 419.289 787.911 419.289 806.28C419.289 824.649 434.18 839.539 452.549 839.539Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.671 821.61C469.671 810.69 462.011 801.84 452.551 801.84C443.091 801.84 435.441 810.69 435.441 821.61C440.543 824.9 446.486 826.65 452.556 826.65C458.627 826.65 464.569 824.9 469.671 821.61V821.61Z",
    fill: "#DADDDF",
    style: {
      baselineShift: 0,
      fill: "rgb(218, 221, 223)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.55 804.51C457.686 804.51 461.85 800.346 461.85 795.21C461.85 790.074 457.686 785.91 452.55 785.91C447.414 785.91 443.25 790.074 443.25 795.21C443.25 800.346 447.414 804.51 452.55 804.51Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.851 773.33H508.281V778.33H787.851V773.33Z",
    fill: "#B2B6BB",
    style: {
      baselineShift: 0,
      fill: "rgb(178, 182, 187)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.29 795.699H508V800.699H687.29V795.699Z",
    fill: "#B2B6BB",
    style: {
      baselineShift: 0,
      fill: "rgb(178, 182, 187)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.34 817.65L522.85 824.75L530.69 825.89L525.01 831.42L526.35 839.22L519.34 835.54L512.33 839.22L513.67 831.42L508 825.89L515.84 824.75L519.34 817.65Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.28 817.65L561.78 824.75L569.62 825.89L563.95 831.42L565.29 839.22L558.28 835.54L551.27 839.22L552.61 831.42L546.93 825.89L554.77 824.75L558.28 817.65Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.211 817.65L600.721 824.75L608.561 825.89L602.881 831.42L604.221 839.22L597.211 835.54L590.201 839.22L591.541 831.42L585.871 825.89L593.711 824.75L597.211 817.65Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.149 817.65L639.649 824.75L647.489 825.89L641.819 831.42L643.159 839.22L636.149 835.54L629.139 839.22L630.479 831.42L624.809 825.89L632.639 824.75L636.149 817.65Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.078 817.65L678.588 824.75L686.428 825.89L680.748 831.42L682.088 839.22L675.078 835.54L668.068 839.22L669.408 831.42L663.738 825.89L671.578 824.75L675.078 817.65Z",
    fill: "#DADDDF",
    style: {
      baselineShift: 0,
      fill: "rgb(218, 221, 223)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.979 835.54L667.969 839.22L669.299 831.42L663.629 825.89L671.469 824.75L674.979 817.65V835.54Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.208 332.64C414.522 332.64 418.018 329.143 418.018 324.83C418.018 320.516 414.522 317.02 410.208 317.02C405.895 317.02 402.398 320.516 402.398 324.83C402.398 329.143 405.895 332.64 410.208 332.64Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.119 332.64C443.432 332.64 446.929 329.143 446.929 324.83C446.929 320.516 443.432 317.02 439.119 317.02C434.805 317.02 431.309 320.516 431.309 324.83C431.309 329.143 434.805 332.64 439.119 332.64Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.029 332.64C472.342 332.64 475.839 329.143 475.839 324.83C475.839 320.516 472.342 317.02 468.029 317.02C463.715 317.02 460.219 320.516 460.219 324.83C460.219 329.143 463.715 332.64 468.029 332.64Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1368.38 1090.05H175.379C174.981 1090.05 174.6 1089.89 174.318 1089.61C174.037 1089.33 173.879 1088.95 173.879 1088.55C173.879 1088.15 174.037 1087.77 174.318 1087.49C174.6 1087.21 174.981 1087.05 175.379 1087.05H1368.38C1368.78 1087.05 1369.16 1087.21 1369.44 1087.49C1369.72 1087.77 1369.88 1088.15 1369.88 1088.55C1369.88 1088.95 1369.72 1089.33 1369.44 1089.61C1369.16 1089.89 1368.78 1090.05 1368.38 1090.05Z",
    fill: "#B2B6BB",
    style: {
      baselineShift: 0,
      fill: "rgb(178, 182, 187)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.16 920.301H1126.24C1131.19 920.301 1136.09 921.276 1140.66 923.171C1145.24 925.066 1149.39 927.843 1152.89 931.344C1156.39 934.845 1159.17 939.001 1161.06 943.575C1162.95 948.149 1163.92 953.051 1163.92 958.001V975.841C1163.92 986.062 1159.86 995.865 1152.63 1003.09C1145.4 1010.32 1135.6 1014.38 1125.38 1014.38H879.16V920.301Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1376.3 959.001V973.151C1376.33 980.389 1374.53 987.518 1371.08 993.881C1364.41 1006.13 1352 1014.36 1337.79 1014.36H871.53C870.769 1014.33 870.02 1014.16 869.328 1013.84C868.635 1013.53 868.011 1013.08 867.493 1012.52C866.974 1011.96 866.571 1011.31 866.306 1010.59C866.041 1009.88 865.92 1009.12 865.95 1008.36V1006.24C865.922 1005.48 866.044 1004.72 866.309 1004.01C866.574 1003.3 866.978 1002.64 867.496 1002.08C868.014 1001.53 868.637 1001.08 869.329 1000.76C870.021 1000.44 870.769 1000.27 871.53 1000.24H1155.76C1157.3 998.237 1158.64 996.086 1159.76 993.821C1162.52 988.224 1163.95 982.062 1163.93 975.821V957.821C1163.93 954.596 1163.55 951.383 1162.78 948.251C1161.55 943.188 1159.31 938.426 1156.19 934.251H871.53C870.769 934.224 870.021 934.047 869.329 933.731C868.637 933.414 868.014 932.965 867.496 932.407C866.978 931.85 866.574 931.196 866.309 930.483C866.044 929.77 865.922 929.011 865.95 928.251V926.141C865.922 925.38 866.044 924.622 866.309 923.908C866.574 923.195 866.978 922.541 867.496 921.984C868.014 921.427 868.637 920.977 869.329 920.661C870.021 920.344 870.769 920.168 871.53 920.141H1340.14C1356.66 920.141 1370.58 931.991 1374.91 948.141C1375.86 951.682 1376.32 955.335 1376.3 959.001V959.001Z",
    fill: "#B2B6BB",
    style: {
      baselineShift: 0,
      fill: "rgb(178, 182, 187)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1374.91 948.341H1162.77C1161.54 943.278 1159.3 938.516 1156.18 934.341H871.529C870.769 934.313 870.021 934.137 869.329 933.82C868.637 933.504 868.014 933.054 867.495 932.497C866.977 931.94 866.574 931.286 866.309 930.573C866.043 929.86 865.921 929.101 865.949 928.341V926.23C865.921 925.47 866.043 924.711 866.309 923.998C866.574 923.285 866.977 922.631 867.495 922.074C868.014 921.516 868.637 921.067 869.329 920.751C870.021 920.434 870.769 920.258 871.529 920.23H1340.14C1356.66 920.3 1370.58 932.151 1374.91 948.341Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M879.16 967.33L913.68 968.91L879.16 969.87V967.33Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M879.16 982.09L961.29 983.67L879.16 984.63V982.09Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086.02 1087.33H838.45C830.339 1087.33 822.561 1084.11 816.826 1078.37C811.091 1072.64 807.87 1064.86 807.87 1056.75V1042.87C807.87 1035.26 810.894 1027.95 816.278 1022.57C821.663 1017.18 828.965 1014.16 836.579 1014.16H1086.02V1087.33V1087.33Z",
    fill: "#868A91",
    style: {
      baselineShift: 0,
      fill: "rgb(134, 138, 145)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1351.34 1087.33H1070.04C1062.08 1087.33 1054.45 1084.17 1048.83 1078.54C1043.2 1072.92 1040.04 1065.29 1040.04 1057.33V1043.5C1040.04 1035.73 1043.13 1028.27 1048.62 1022.77C1054.12 1017.28 1061.58 1014.19 1069.35 1014.19H1351.34V1087.36V1087.33Z",
    fill: "#F4F4F4",
    style: {
      baselineShift: 0,
      fill: "rgb(244, 244, 244)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1021.07 1087.34H1361.32C1363.77 1087.34 1365.75 1085.36 1365.75 1082.91V1080.83C1365.75 1078.38 1363.77 1076.4 1361.32 1076.4H1021.07C1018.62 1076.4 1016.64 1078.38 1016.64 1080.83V1082.91C1016.64 1085.36 1018.62 1087.34 1021.07 1087.34Z",
    fill: "#868A91",
    style: {
      baselineShift: 0,
      fill: "rgb(134, 138, 145)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1021.07 1025.11H1361.32C1363.77 1025.11 1365.75 1023.13 1365.75 1020.68V1018.6C1365.75 1016.15 1363.77 1014.17 1361.32 1014.17H1021.07C1018.62 1014.17 1016.64 1016.15 1016.64 1018.6V1020.68C1016.64 1023.13 1018.62 1025.11 1021.07 1025.11Z",
    fill: "#868A91",
    style: {
      baselineShift: 0,
      fill: "rgb(134, 138, 145)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1351.31 1050.75L1313.57 1051.98L1351.31 1052.72V1050.75Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1351.31 1033.91L1261.53 1035.14L1351.31 1035.88V1033.91Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1262.45 1034.9C1264.93 1037.11 1266.72 1040 1267.57 1043.21C1267.81 1044.16 1267.94 1045.13 1267.97 1046.1C1268.18 1052.97 1267.97 1068.5 1267.97 1068.5L1279.33 1060.74L1290.66 1068.5V1047.5C1290.66 1043.5 1289.66 1039.64 1287.88 1037.1C1287.01 1035.87 1285.95 1034.95 1284.74 1034.95L1262.45 1034.9Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1262.45 1034.9C1264.93 1037.11 1266.72 1040 1267.57 1043.21L1290.33 1043.52C1290.33 1043.52 1289.44 1036.12 1284.74 1034.9H1262.45Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816.691 813H1052.14C1063.56 813 1074.52 817.538 1082.6 825.615C1090.67 833.692 1095.21 844.647 1095.21 856.07V876.46C1095.21 888.13 1090.58 899.321 1082.32 907.573C1074.07 915.824 1062.88 920.46 1051.21 920.46H816.691V813Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1095.34 854.71V877.85C1095.28 887.73 1090.7 896.3 1083.97 900.85C1080.68 903.135 1076.77 904.369 1072.76 904.39H809.359C806.269 904.39 803.77 907.39 803.77 911.06V913.79C803.77 917.48 806.269 920.47 809.359 920.47H1264.36C1277.42 920.47 1288.95 912.72 1295.92 900.85C1300.56 892.827 1302.98 883.709 1302.92 874.44V856.22C1302.94 849.78 1301.72 843.396 1299.32 837.42C1293.48 823 1281.09 813 1266.74 813H809.359C806.269 813 803.77 816 803.77 819.67V822.4C803.77 826.09 806.269 829.08 809.359 829.08H1073.57C1079.88 829.08 1085.57 832.29 1089.57 837.42C1093.33 842.397 1095.36 848.471 1095.34 854.71V854.71Z",
    fill: "#868A91",
    style: {
      baselineShift: 0,
      fill: "rgb(134, 138, 145)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M803.77 911.091V913.821C803.77 917.511 806.269 920.501 809.359 920.501H1264.36C1277.42 920.501 1288.95 912.751 1295.92 900.881H1084C1080.71 903.166 1076.8 904.4 1072.79 904.421H809.359C806.269 904.421 803.77 907.411 803.77 911.091Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M816.691 866.75L850.461 868.56L816.691 869.64V866.75Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M816.691 842.01L897.021 843.82L816.691 844.9V842.01Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.19 843.461C896.19 843.461 890.89 846.871 889.14 852.461C888.817 853.475 888.632 854.528 888.59 855.591C888.3 863.041 888.59 879.891 888.59 879.891L872.94 871.461L857.32 879.891V857.061C857.32 852.741 858.66 848.541 861.15 845.791C861.669 845.123 862.32 844.571 863.064 844.17C863.808 843.769 864.628 843.527 865.47 843.461H896.19Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M896.19 843.459C896.19 843.459 890.89 846.869 889.14 852.459L857.77 852.789C857.77 852.789 858.999 844.789 865.469 843.449L896.19 843.459Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.329 811.779C291.154 811.792 289.997 812.069 288.943 812.588C287.89 813.107 286.965 813.856 286.239 814.779C276.339 827.499 274.339 854.319 278.419 861.279C283.219 869.479 278.259 872.419 279.419 879.839C280.359 885.839 288.819 890.419 291.959 891.929C292.325 892.102 292.724 892.192 293.129 892.192C293.534 892.192 293.933 892.102 294.299 891.929C297.549 890.359 306.519 885.509 307.299 879.429C308.229 871.979 303.179 869.189 307.739 860.849C311.609 853.769 308.799 827.019 298.529 814.599C297.769 813.705 296.819 812.991 295.748 812.51C294.677 812.029 293.513 811.793 292.339 811.819",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    style: {
      baselineShift: 0,
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    style: {
      baselineShift: 0,
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M292.329 811.779C291.154 811.792 289.997 812.069 288.943 812.588C287.89 813.107 286.965 813.856 286.239 814.779C276.339 827.499 274.339 854.319 278.419 861.279C283.219 869.479 278.259 872.419 279.419 879.839C280.359 885.839 288.819 890.419 291.959 891.929C292.325 892.102 292.724 892.192 293.129 892.192C293.534 892.192 293.933 892.102 294.299 891.929C297.549 890.359 306.519 885.509 307.299 879.429C308.229 871.979 303.179 869.189 307.739 860.849C311.609 853.769 308.799 827.019 298.529 814.599C297.769 813.705 296.819 812.991 295.748 812.51C294.677 812.029 293.513 811.793 292.339 811.819",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M362.211 884.9C361.328 884.127 360.283 883.561 359.153 883.245C358.023 882.928 356.837 882.868 355.681 883.07C339.841 886.07 320.561 904.8 319.001 912.71C317.171 922.04 311.501 920.95 307.451 927.27C304.161 932.4 307.451 941.43 308.831 944.64C308.987 945.013 309.225 945.345 309.528 945.612C309.831 945.879 310.191 946.073 310.581 946.18C314.061 947.18 323.991 949.48 328.581 945.43C334.211 940.43 332.281 935.04 341.221 931.81C348.801 929.08 364.441 907.19 364.981 891.08C365.006 889.907 364.768 888.744 364.286 887.674C363.803 886.605 363.087 885.657 362.191 884.9",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.281 902.169C219.529 902.791 218.925 903.574 218.515 904.46C218.105 905.346 217.899 906.312 217.911 907.288C218.231 920.688 231.051 939.019 237.341 941.359C244.751 944.109 243.101 948.618 247.751 952.788C251.521 956.168 259.381 954.659 262.191 953.979C262.518 953.897 262.822 953.744 263.082 953.529C263.341 953.314 263.549 953.044 263.691 952.739C264.961 950.019 268.191 942.179 265.481 937.859C262.171 932.569 257.481 933.428 255.991 925.658C254.761 919.058 238.881 903.299 225.731 900.709C224.771 900.527 223.783 900.565 222.839 900.817C221.896 901.07 221.021 901.532 220.281 902.169",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.449 932.109C338.759 931.616 337.966 931.284 337.13 931.138C336.294 930.993 335.436 931.038 334.619 931.269C323.409 934.529 310.859 949.419 310.299 955.269C309.639 962.119 305.479 961.739 303.009 966.579C301.009 970.509 304.009 976.779 305.239 978.999C305.381 979.256 305.576 979.479 305.813 979.652C306.05 979.825 306.322 979.943 306.609 979.999C309.189 980.459 316.509 981.419 319.539 978.179C323.249 974.179 321.469 970.419 327.679 967.469C332.949 964.949 342.679 948.059 341.899 936.469C341.836 935.621 341.583 934.798 341.159 934.061C340.735 933.323 340.151 932.691 339.449 932.209",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.632 851.869C254.7 852.158 253.845 852.652 253.128 853.315C252.412 853.977 251.853 854.792 251.492 855.699C246.682 868.209 251.552 890.049 256.492 894.609C262.292 899.979 259.052 903.519 261.752 909.139C263.952 913.709 271.752 915.299 274.662 915.739C274.994 915.788 275.332 915.763 275.652 915.664C275.972 915.565 276.266 915.396 276.512 915.169C278.722 913.169 284.702 907.169 283.842 902.089C282.792 895.939 278.102 894.929 279.722 887.189C281.092 880.629 272.412 860.009 261.242 852.589C260.422 852.059 259.493 851.719 258.524 851.594C257.555 851.47 256.57 851.564 255.642 851.869",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.491 854.82C332.628 854.362 331.673 854.104 330.697 854.064C329.721 854.024 328.748 854.204 327.851 854.59C315.601 860.04 303.601 878.93 303.851 885.59C304.161 893.49 299.361 893.7 297.301 899.59C295.631 904.37 300.041 911.04 301.761 913.38C301.959 913.65 302.216 913.873 302.512 914.03C302.808 914.188 303.136 914.277 303.471 914.29C306.471 914.42 314.961 914.38 317.901 910.22C321.511 905.13 318.901 901.1 325.521 896.77C331.131 893.1 339.581 872.38 336.921 859.24C336.717 858.287 336.302 857.391 335.707 856.619C335.112 855.847 334.351 855.219 333.481 854.78",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      baselineShift: 0,
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      baselineShift: 0,
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M255.632 851.869C254.7 852.158 253.845 852.652 253.128 853.315C252.412 853.977 251.853 854.792 251.492 855.699C246.682 868.209 251.552 890.049 256.492 894.609C262.292 899.979 259.052 903.519 261.752 909.139C263.952 913.709 271.752 915.299 274.662 915.739C274.994 915.788 275.332 915.763 275.652 915.664C275.972 915.565 276.266 915.396 276.512 915.169C278.722 913.169 284.702 907.169 283.842 902.089C282.792 895.939 278.102 894.929 279.722 887.189C281.092 880.629 272.412 860.009 261.242 852.589C260.422 852.059 259.493 851.719 258.524 851.594C257.555 851.47 256.57 851.564 255.642 851.869",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      baselineShift: 0,
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      baselineShift: 0,
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M333.491 854.82C332.628 854.362 331.673 854.104 330.697 854.064C329.721 854.024 328.748 854.204 327.851 854.59C315.601 860.04 303.601 878.93 303.851 885.59C304.161 893.49 299.361 893.7 297.301 899.59C295.631 904.37 300.041 911.04 301.761 913.38C301.959 913.65 302.216 913.873 302.512 914.03C302.808 914.188 303.136 914.277 303.471 914.29C306.471 914.42 314.961 914.38 317.901 910.22C321.511 905.13 318.901 901.1 325.521 896.77C331.131 893.1 339.581 872.38 336.921 859.24C336.717 858.287 336.302 857.391 335.707 856.619C335.112 855.847 334.351 855.219 333.481 854.78",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M290.142 857.749C289.171 857.718 288.206 857.904 287.317 858.293C286.428 858.682 285.637 859.265 285.002 859.999C276.372 870.259 273.872 892.489 277.002 898.399C280.732 905.399 276.512 907.659 277.242 913.859C277.832 918.859 284.722 922.959 287.292 924.299C287.589 924.455 287.918 924.543 288.254 924.555C288.589 924.567 288.924 924.504 289.232 924.369C291.982 923.169 299.592 919.419 300.422 914.369C301.422 908.209 297.322 905.729 301.372 898.939C304.812 893.179 303.322 870.859 295.172 860.209C294.571 859.44 293.806 858.816 292.932 858.383C292.057 857.951 291.097 857.72 290.122 857.709",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.25 957.83C253.623 958.266 253.101 958.838 252.724 959.502C252.347 960.167 252.123 960.908 252.07 961.67C251.45 972.17 260.29 987.33 265.07 989.56C270.68 992.2 269.07 995.61 272.47 999.17C275.2 1002.06 281.47 1001.39 283.68 1001.03C283.94 1000.99 284.187 1000.89 284.403 1000.74C284.619 1000.59 284.8 1000.4 284.93 1000.17C286.1 998.17 289.13 992.17 287.29 988.65C285.05 984.3 281.29 984.65 280.67 978.49C280.13 973.26 268.73 959.91 258.67 957.03C257.931 956.83 257.157 956.798 256.404 956.936C255.651 957.074 254.939 957.38 254.32 957.83",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      baselineShift: 0,
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      baselineShift: 0,
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M339.449 932.109C338.759 931.616 337.966 931.284 337.13 931.138C336.294 930.993 335.436 931.038 334.619 931.269C323.409 934.529 310.859 949.419 310.299 955.269C309.639 962.119 305.479 961.739 303.009 966.579C301.009 970.509 304.009 976.779 305.239 978.999C305.381 979.256 305.576 979.479 305.813 979.652C306.05 979.825 306.322 979.943 306.609 979.999C309.189 980.459 316.509 981.419 319.539 978.179C323.249 974.179 321.469 970.419 327.679 967.469C332.949 964.949 342.679 948.059 341.899 936.469C341.836 935.621 341.583 934.798 341.159 934.061C340.735 933.323 340.151 932.691 339.449 932.209",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      baselineShift: 0,
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      baselineShift: 0,
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M290.142 857.749C289.171 857.718 288.206 857.904 287.317 858.293C286.428 858.682 285.637 859.265 285.002 859.999C276.372 870.259 273.872 892.489 277.002 898.399C280.732 905.399 276.512 907.659 277.242 913.859C277.832 918.859 284.722 922.959 287.292 924.299C287.589 924.455 287.918 924.543 288.254 924.555C288.589 924.567 288.924 924.504 289.232 924.369C291.982 923.169 299.592 919.419 300.422 914.369C301.422 908.209 297.322 905.729 301.372 898.939C304.812 893.179 303.322 870.859 295.172 860.209C294.571 859.44 293.806 858.816 292.932 858.383C292.057 857.951 291.097 857.72 290.122 857.709",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      baselineShift: 0,
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      baselineShift: 0,
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M254.25 957.83C253.623 958.266 253.101 958.838 252.724 959.502C252.347 960.167 252.123 960.908 252.07 961.67C251.45 972.17 260.29 987.33 265.07 989.56C270.68 992.2 269.07 995.61 272.47 999.17C275.2 1002.06 281.47 1001.39 283.68 1001.03C283.94 1000.99 284.187 1000.89 284.403 1000.74C284.619 1000.59 284.8 1000.4 284.93 1000.17C286.1 998.17 289.13 992.17 287.29 988.65C285.05 984.3 281.29 984.65 280.67 978.49C280.13 973.26 268.73 959.91 258.67 957.03C257.931 956.83 257.157 956.798 256.404 956.936C255.651 957.074 254.939 957.38 254.32 957.83",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M291.931 1015.61L291.141 1015.37C291.331 1014.73 310.481 951.529 339.561 933.719L339.991 934.419C311.181 952.069 292.121 1014.97 291.931 1015.61",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.701 1015.59C288.071 999.389 255.441 960.709 255.121 960.319L255.751 959.779C257.101 961.379 288.841 999.029 291.511 1015.46L290.701 1015.59Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.722 1015.52L290.902 1015.42L294.752 982.168C296.855 963.409 304.892 945.812 317.692 931.938L360.092 886.148L360.702 886.708L318.292 932.498C305.618 946.246 297.659 963.677 295.572 982.258L291.722 1015.52Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.571 1015.63C290.361 1014.87 268.621 938.629 221.711 903.949L222.201 903.279C269.341 938.159 291.151 1014.64 291.371 1015.41L290.571 1015.63Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.933 861.566L289.113 861.576L290.94 1015.45L291.759 1015.44L289.933 861.566Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.492 965.629C289.672 916.839 331.722 856.959 332.152 856.359L332.822 856.839C332.402 857.439 290.502 917.099 291.312 965.609L290.492 965.629Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.489 967.909C289.489 949.209 255.389 854.909 255.039 853.989L255.819 853.709C256.159 854.659 290.289 949.049 291.309 967.859L290.489 967.909Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.124 813.836L291.305 813.867L292.954 857.786L293.773 857.755L292.124 813.836Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.081 971.013L255.758 971.777L268.13 977.001L268.453 976.236L256.081 971.013Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.618 916.873L223.309 917.633L244.894 926.433L245.203 925.673L223.618 916.873Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.513 866.824L251.867 867.33L266.299 885.749L266.945 885.244L252.513 866.824Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.445 878.531L290.016 904.926L290.815 905.151L298.244 878.756L297.445 878.531Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.372 864.021L314.355 886.156L315.178 886.268L318.194 864.133L317.372 864.021Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.079 914L334.289 913.79C336.289 905.79 339.419 893.69 339.499 893.1H340.319C340.319 893.52 336.659 907.83 335.079 913.96",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.161 949.689L315.766 960.598L316.184 961.303L334.579 950.394L334.161 949.689Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M291.931 1015.61L291.141 1015.37C291.331 1014.73 310.481 951.529 339.561 933.719L339.991 934.419C311.181 952.069 292.121 1014.97 291.931 1015.61",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M290.701 1015.59C288.071 999.389 255.441 960.709 255.121 960.319L255.751 959.779C257.101 961.379 288.841 999.029 291.511 1015.46L290.701 1015.59Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M291.722 1015.52L290.902 1015.42L294.752 982.17C296.855 963.411 304.892 945.814 317.692 931.94L360.092 886.15L360.702 886.71L318.292 932.5C305.618 946.248 297.659 963.679 295.572 982.26L291.722 1015.52Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M290.571 1015.63C290.361 1014.87 268.621 938.629 221.711 903.949L222.201 903.279C269.341 938.159 291.151 1014.64 291.371 1015.41L290.571 1015.63Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M289.933 861.566L289.113 861.576L290.94 1015.45L291.759 1015.44L289.933 861.566Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M290.492 965.629C289.672 916.839 331.722 856.959 332.152 856.359L332.822 856.839C332.402 857.439 290.502 917.099 291.312 965.609L290.492 965.629Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M290.489 967.909C289.489 949.209 255.389 854.909 255.039 853.989L255.819 853.709C256.159 854.659 290.289 949.049 291.309 967.859L290.489 967.909Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M292.128 813.836L291.309 813.867L292.957 857.786L293.777 857.755L292.128 813.836Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M256.081 971.013L255.758 971.777L268.13 977.001L268.453 976.236L256.081 971.013Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M223.618 916.873L223.309 917.633L244.894 926.433L245.203 925.673L223.618 916.873Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M252.513 866.824L251.867 867.33L266.299 885.749L266.945 885.244L252.513 866.824Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M297.445 878.531L290.016 904.926L290.815 905.151L298.244 878.756L297.445 878.531Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M317.372 864.021L314.355 886.156L315.178 886.268L318.194 864.133L317.372 864.021Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M335.079 914L334.289 913.79C336.289 905.79 339.419 893.69 339.499 893.1H340.319C340.319 893.52 336.659 907.83 335.079 913.96",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M334.161 949.689L315.766 960.598L316.184 961.303L334.579 950.394L334.161 949.689Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M306.51 1086.6H276.51C272.284 1086.6 268.232 1084.92 265.243 1081.93C262.254 1078.95 260.573 1074.89 260.57 1070.67V1016.49H322.43V1070.67C322.43 1074.89 320.752 1078.95 317.765 1081.93C314.777 1084.92 310.725 1086.6 306.5 1086.6",
    fill: "#868A91",
    style: {
      baselineShift: 0,
      fill: "rgb(134, 138, 145)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.922 1086.6H306.512C308.604 1086.6 310.675 1086.19 312.608 1085.39C314.541 1084.59 316.297 1083.41 317.776 1081.93C319.255 1080.45 320.429 1078.7 321.229 1076.76C322.03 1074.83 322.442 1072.76 322.442 1070.67V1023.14L260.752 1023.91L260.582 1026.55H306.002V1071.76C306.002 1071.76 309.302 1086.6 292.002 1086.6",
    fill: "#606266",
    style: {
      baselineShift: 0,
      fill: "rgb(96, 98, 102)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.931 1023.91H258.271C257.791 1023.91 257.331 1023.72 256.991 1023.38C256.652 1023.04 256.461 1022.58 256.461 1022.1V1018.31C256.46 1018.07 256.506 1017.83 256.596 1017.61C256.686 1017.39 256.819 1017.19 256.988 1017.02C257.156 1016.85 257.356 1016.72 257.576 1016.63C257.796 1016.54 258.032 1016.49 258.271 1016.49H323.931C324.17 1016.49 324.406 1016.54 324.626 1016.63C324.846 1016.72 325.046 1016.85 325.214 1017.02C325.383 1017.19 325.516 1017.39 325.606 1017.61C325.696 1017.83 325.742 1018.07 325.741 1018.31V1022.1C325.741 1022.58 325.55 1023.04 325.211 1023.38C324.871 1023.72 324.411 1023.91 323.931 1023.91",
    fill: "#868A91",
    style: {
      baselineShift: 0,
      fill: "rgb(134, 138, 145)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.739 1022.1V1018.31C325.731 1018.06 325.675 1017.82 325.572 1017.59C325.47 1017.37 325.324 1017.16 325.143 1016.99C324.961 1016.82 324.749 1016.69 324.516 1016.61C324.284 1016.52 324.037 1016.48 323.789 1016.49H310.789V1023.91H323.789C324.036 1023.92 324.282 1023.88 324.514 1023.79C324.746 1023.71 324.958 1023.58 325.139 1023.41C325.32 1023.24 325.467 1023.04 325.569 1022.81C325.672 1022.59 325.73 1022.35 325.739 1022.1",
    fill: "#606266",
    style: {
      baselineShift: 0,
      fill: "rgb(96, 98, 102)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440 426.01H288V484H440V426.01Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424 500V480H407L424 500Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.637 459.115H343.344V461.551H329.642V438.957H332.637V459.115ZM353.26 461.861C350.984 461.861 349.132 461.116 347.704 459.627C346.277 458.127 345.563 456.125 345.563 453.621V453.094C345.563 451.428 345.879 449.944 346.51 448.64C347.151 447.326 348.041 446.302 349.179 445.568C350.327 444.823 351.568 444.45 352.903 444.45C355.086 444.45 356.782 445.169 357.993 446.607C359.203 448.045 359.808 450.104 359.808 452.783V453.978H348.434C348.475 455.633 348.956 456.973 349.877 457.997C350.808 459.011 351.987 459.518 353.415 459.518C354.429 459.518 355.287 459.311 355.991 458.897C356.694 458.483 357.31 457.935 357.837 457.252L359.591 458.618C358.184 460.78 356.074 461.861 353.26 461.861ZM352.903 446.809C351.744 446.809 350.772 447.233 349.986 448.082C349.199 448.919 348.713 450.099 348.527 451.62H356.937V451.402C356.855 449.944 356.462 448.816 355.758 448.019C355.055 447.213 354.103 446.809 352.903 446.809ZM373.51 461.551C373.345 461.22 373.21 460.63 373.107 459.782C371.772 461.168 370.179 461.861 368.327 461.861C366.672 461.861 365.312 461.396 364.246 460.465C363.191 459.523 362.663 458.333 362.663 456.896C362.663 455.147 363.325 453.792 364.65 452.83C365.984 451.857 367.857 451.371 370.267 451.371H373.06V450.052C373.06 449.049 372.76 448.252 372.16 447.663C371.56 447.063 370.676 446.763 369.507 446.763C368.483 446.763 367.624 447.021 366.931 447.538C366.238 448.056 365.891 448.682 365.891 449.416H363.005C363.005 448.578 363.3 447.771 363.889 446.995C364.489 446.209 365.296 445.588 366.31 445.133C367.334 444.678 368.457 444.45 369.677 444.45C371.612 444.45 373.127 444.937 374.224 445.909C375.321 446.871 375.89 448.2 375.931 449.897V457.625C375.931 459.166 376.127 460.392 376.521 461.302V461.551H373.51ZM368.746 459.363C369.646 459.363 370.5 459.13 371.307 458.665C372.114 458.199 372.698 457.594 373.06 456.849V453.404H370.81C367.293 453.404 365.534 454.433 365.534 456.492C365.534 457.392 365.834 458.096 366.434 458.602C367.034 459.109 367.805 459.363 368.746 459.363ZM388.547 447.337C388.112 447.264 387.642 447.228 387.135 447.228C385.252 447.228 383.974 448.03 383.302 449.633V461.551H380.431V444.761H383.224L383.271 446.7C384.212 445.2 385.547 444.45 387.274 444.45C387.833 444.45 388.257 444.523 388.547 444.668V447.337ZM393.916 444.761L394.009 446.871C395.292 445.257 396.968 444.45 399.037 444.45C402.585 444.45 404.375 446.452 404.406 450.456V461.551H401.535V450.44C401.525 449.23 401.245 448.335 400.697 447.756C400.159 447.176 399.316 446.887 398.168 446.887C397.237 446.887 396.419 447.135 395.716 447.632C395.012 448.128 394.464 448.78 394.071 449.587V461.551H391.2V444.761H393.916Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856 636H1008V578.01H856V636Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872 652V632H889L872 652Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.787 613.551H910.793V603.107H899.403V613.551H896.423V590.957H899.403V600.671H910.793V590.957H913.787V613.551ZM925.596 613.861C923.32 613.861 921.469 613.116 920.041 611.627C918.613 610.127 917.9 608.125 917.9 605.621V605.094C917.9 603.428 918.215 601.944 918.846 600.64C919.488 599.326 920.377 598.302 921.515 597.568C922.663 596.823 923.905 596.45 925.239 596.45C927.422 596.45 929.119 597.169 930.329 598.607C931.54 600.045 932.145 602.104 932.145 604.783V605.978H920.77C920.812 607.633 921.293 608.973 922.213 609.997C923.145 611.011 924.324 611.518 925.751 611.518C926.765 611.518 927.624 611.311 928.327 610.897C929.031 610.483 929.646 609.935 930.174 609.252L931.927 610.618C930.521 612.78 928.41 613.861 925.596 613.861ZM925.239 598.809C924.081 598.809 923.108 599.233 922.322 600.082C921.536 600.919 921.05 602.099 920.863 603.62H929.274V603.402C929.191 601.944 928.798 600.816 928.095 600.019C927.391 599.213 926.439 598.809 925.239 598.809ZM938.6 613.551H935.729V589.716H938.6V613.551ZM946.328 613.551H943.457V589.716H946.328V613.551ZM950.176 605.001C950.176 603.356 950.497 601.876 951.138 600.563C951.79 599.249 952.69 598.235 953.838 597.521C954.997 596.807 956.316 596.45 957.795 596.45C960.082 596.45 961.928 597.242 963.335 598.825C964.752 600.407 965.461 602.513 965.461 605.14V605.342C965.461 606.977 965.145 608.445 964.514 609.749C963.894 611.042 962.999 612.051 961.83 612.775C960.671 613.499 959.337 613.861 957.826 613.861C955.55 613.861 953.704 613.07 952.287 611.487C950.88 609.904 950.176 607.809 950.176 605.202V605.001ZM953.062 605.342C953.062 607.204 953.492 608.699 954.35 609.827C955.219 610.954 956.378 611.518 957.826 611.518C959.285 611.518 960.444 610.949 961.302 609.811C962.161 608.663 962.59 607.059 962.59 605.001C962.59 603.159 962.151 601.669 961.271 600.532C960.402 599.383 959.244 598.809 957.795 598.809C956.378 598.809 955.235 599.373 954.366 600.5C953.497 601.628 953.062 603.242 953.062 605.342ZM972.273 607.173H969.682L969.48 590.957H972.49L972.273 607.173ZM969.371 612.108C969.371 611.642 969.511 611.254 969.79 610.944C970.08 610.623 970.504 610.463 971.063 610.463C971.621 610.463 972.046 610.623 972.335 610.944C972.625 611.254 972.77 611.642 972.77 612.108C972.77 612.573 972.625 612.961 972.335 613.271C972.046 613.571 971.621 613.721 971.063 613.721C970.504 613.721 970.08 613.571 969.79 613.271C969.511 612.961 969.371 612.573 969.371 612.108Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.378 981.48L932.848 1012.14C933.662 1012.72 934.588 1013.12 935.568 1013.32C936.547 1013.52 937.558 1013.52 938.534 1013.3C939.509 1013.08 940.429 1012.66 941.233 1012.07C942.036 1011.48 942.706 1010.72 943.198 1009.85C944.465 1007.55 945.49 1005.12 946.258 1002.61C946.817 1000.86 947.768 999.258 949.038 997.93L996.478 948L1015.3 927L994.808 903.35L932.418 983.25C932.095 983.689 931.649 984.023 931.137 984.209C930.625 984.396 930.069 984.428 929.538 984.3L898.328 976.12C895.562 975.358 892.625 975.491 889.938 976.5C887.618 977.44 885.908 979 888.378 981.48Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M949.001 997.93C947.731 999.259 946.78 1000.86 946.221 1002.61C945.442 1005.16 944.396 1007.61 943.101 1009.94C942.596 1010.79 941.919 1011.53 941.113 1012.11C940.307 1012.69 939.39 1013.09 938.42 1013.3C937.45 1013.5 936.448 1013.5 935.477 1013.3C934.506 1013.1 933.588 1012.7 932.781 1012.12L888.341 981.48C887.952 981.212 887.664 980.821 887.523 980.37C887.381 979.918 887.395 979.433 887.561 978.99L931.681 1007.21C936.431 1010.49 939.681 1005.76 941.451 1001.95C943.015 998.55 945.034 995.378 947.451 992.52L1008.82 919.65L1015.22 927.03L996.401 948.03L949.001 997.93Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M906.091 978.179L898.331 976.179C895.564 975.418 892.627 975.551 889.941 976.559C887.621 977.469 885.941 979.009 888.381 981.559L932.851 1012.22C933.664 1012.8 934.591 1013.2 935.57 1013.4C936.549 1013.6 937.56 1013.6 938.536 1013.38C939.512 1013.16 940.431 1012.74 941.235 1012.15C942.039 1011.56 942.708 1010.8 943.201 1009.93C944.467 1007.63 945.492 1005.2 946.261 1002.69C946.587 1001.68 947.044 1000.73 947.621 999.839V999.839C903.171 986.229 906.091 978.179 906.091 978.179Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M887.222 978.801C887.042 979.541 887.332 980.431 888.382 981.481L932.852 1012.14C933.793 1012.8 934.878 1013.23 936.017 1013.39C937.157 1013.54 938.317 1013.42 939.402 1013.04L887.222 978.801Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1081.65 853.5H1039.65C1031.27 853.5 1024 858 1014.75 870.63L933 979L953 995L1049.65 903L1081.65 853.5Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.5 704.501L1123.69 708.331C1116.86 709.661 1110.41 718.811 1108.69 725.551L1078.49 793.551L1100.49 851.551L1210.49 853.551C1210.49 853.551 1211.49 809.551 1216.49 790.551L1249.65 786.251L1231.65 719.351C1230.72 715.87 1228.76 712.752 1226.02 710.401C1223.29 708.05 1219.92 706.576 1216.34 706.171L1184.48 702.551L1148.5 704.501Z",
    fill: "#3F4249",
    style: {
      baselineShift: 0,
      fill: "rgb(63, 66, 73)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1115.12 747.55C1115.86 746.284 1116.14 744.798 1115.9 743.35C1115.65 742.01 1114.9 741.35 1113 745C1109.35 751.91 1099.59 776.32 1095 786C1095 786 1099 811 1098 821H1112.91C1112.91 821 1114.75 794.63 1107.56 784.75C1105.03 781.178 1103.99 776.757 1104.67 772.43C1105.41 767.4 1109.67 757.3 1115.12 747.55Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1070.3 853.5H1045.16C1045.16 853.5 1021.58 860.5 1025 885.89C1026.52 897.15 1027.9 908.58 1022.09 918.34L948 990H948.07L953.07 995L1047.72 905L1075.58 862.2L1070.3 853.5Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1196.62 624.17C1196.62 624.17 1230.98 623.93 1232.86 656.83C1232.99 659.14 1232.93 661.46 1233.12 663.77C1233.82 672.35 1236.12 689.35 1243.12 696.09L1238.46 697.46C1238.46 697.46 1231.46 688.75 1231.19 681.25C1231.19 681.25 1228.67 692.1 1232.05 699.33C1232.05 699.33 1222.18 706.65 1197.77 707.47C1197.77 707.47 1188.15 690.78 1196.31 672.81C1196.69 671.96 1197.14 671.14 1197.6 670.32C1198.81 668.16 1202.2 660.68 1199.06 648.66L1196.62 624.17Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1205.95 638.309C1206.28 629.352 1200.96 621.88 1194.05 621.619C1187.14 621.358 1181.26 628.408 1180.92 637.366C1180.59 646.323 1185.91 653.795 1192.82 654.056C1199.73 654.316 1205.61 647.267 1205.95 638.309Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1173.26 681.939C1178.92 680.772 1184.13 678.026 1188.29 674.019C1192.45 670.012 1195.4 664.909 1196.78 659.299C1201.94 640.299 1198.35 630.889 1193.48 620.149C1189.82 612.059 1174.66 599.749 1157.72 602.519C1140.62 605.319 1131.05 614.379 1128.91 629.869C1124.91 658.859 1145.48 695.779 1173.26 681.939Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1059.05 1053.14L1109.8 1034.65C1110.74 1034.32 1111.61 1033.8 1112.34 1033.11C1113.07 1032.43 1113.64 1031.6 1114.03 1030.68C1114.42 1029.76 1114.62 1028.77 1114.6 1027.77C1114.58 1026.77 1114.35 1025.79 1113.93 1024.88C1112.78 1022.52 1111.4 1020.28 1109.8 1018.19C1108.69 1016.71 1107.94 1015 1107.6 1013.19L1091.35 945.589L1085.17 918.109L1057.03 921.109L1086.03 1018.25C1086.21 1018.77 1086.23 1019.34 1086.08 1019.87C1085.93 1020.41 1085.63 1020.89 1085.21 1021.25L1060.46 1041.96C1058.24 1043.78 1056.65 1046.25 1055.92 1049.02C1055.32 1051.42 1055.58 1053.71 1059.05 1053.14Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1107.59 1013.22C1107.94 1015.03 1108.69 1016.74 1109.8 1018.22C1111.44 1020.33 1112.84 1022.6 1114 1025C1114.41 1025.91 1114.62 1026.89 1114.62 1027.88C1114.63 1028.87 1114.42 1029.85 1114.03 1030.76C1113.63 1031.67 1113.05 1032.49 1112.33 1033.17C1111.6 1033.84 1110.74 1034.36 1109.8 1034.68L1059.08 1053.16C1058.64 1053.32 1058.15 1053.33 1057.7 1053.18C1057.25 1053.03 1056.87 1052.74 1056.6 1052.35L1105.16 1032.73C1110.58 1030.73 1108.63 1025.35 1106.53 1021.73C1104.67 1018.47 1103.26 1014.98 1102.34 1011.34L1078.48 919.11L1085.2 918.17L1091.38 945.65L1107.59 1013.22Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1179.71 657.699L1188.2 702.449L1184.83 704.729C1172 712.999 1153 715.999 1148.52 704.509L1149.93 674.069L1179.71 657.699Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1149.34 685.219C1153.25 686.759 1152.82 687.519 1156.95 687.029L1159.79 686.619C1160.13 686.585 1160.47 686.501 1160.79 686.369H1160.99C1161.5 686.189 1161.99 686.119 1162.62 685.909C1162.82 685.909 1163.02 685.749 1163.22 685.719C1166 684.844 1168.59 683.464 1170.87 681.649C1170.93 681.586 1171.01 681.538 1171.1 681.509C1171.19 681.489 1171.28 681.489 1171.37 681.509C1171.46 681.515 1171.54 681.539 1171.62 681.579C1171.7 681.619 1171.77 681.677 1171.82 681.749C1171.94 681.893 1172 682.073 1172 682.259C1171.98 682.444 1171.9 682.616 1171.76 682.739C1168.82 685.105 1165.41 686.81 1161.76 687.739C1158.69 690.934 1154.66 693.04 1150.28 693.739C1148.55 693.999 1151.41 693.819 1149.66 693.639L1149.34 685.219Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1142.44 844.43V844.5V844.43Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.92,
    strokeMiterlimit: 10,
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      stroke: "rgb(0, 0, 0)",
      strokeMiterlimit: 10,
      strokeWidth: "0.92px",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1167.72 826.369L1157.95 828.739L1142 826.999C1140.17 827.229 1138.5 828.161 1137.34 829.599L1120.18 844.699C1119.82 845.099 1119.63 845.621 1119.65 846.157C1119.67 846.693 1119.89 847.202 1120.27 847.579V847.579C1120.66 847.952 1121.18 848.16 1121.72 848.16C1122.26 848.16 1122.78 847.952 1123.17 847.579L1137.17 835.899L1127.57 847.539C1127.38 847.806 1127.25 848.117 1127.21 848.444C1127.16 848.771 1127.2 849.104 1127.32 849.413C1127.43 849.722 1127.62 849.997 1127.87 850.215C1128.12 850.432 1128.42 850.585 1128.74 850.659C1129.1 850.741 1129.48 850.724 1129.83 850.612C1130.18 850.499 1130.49 850.295 1130.74 850.019L1140.38 838.359L1133.06 847.239C1132.86 847.483 1132.72 847.774 1132.66 848.085C1132.6 848.396 1132.62 848.717 1132.72 849.018C1132.82 849.318 1133 849.588 1133.23 849.802C1133.47 850.015 1133.75 850.166 1134.06 850.239C1134.37 850.335 1134.69 850.348 1135.01 850.278C1135.32 850.208 1135.61 850.057 1135.85 849.839L1146.41 840.269L1139.27 846.809C1139.08 846.982 1138.93 847.199 1138.83 847.442C1138.74 847.685 1138.7 847.947 1138.73 848.206C1138.76 848.465 1138.85 848.714 1138.99 848.932C1139.13 849.15 1139.32 849.33 1139.55 849.459V849.459C1139.8 849.594 1140.08 849.665 1140.36 849.665C1140.64 849.665 1140.92 849.594 1141.17 849.459L1151.11 844.039C1151.59 843.775 1152.11 843.616 1152.66 843.571C1153.2 843.526 1153.75 843.597 1154.26 843.779L1158.39 844.839C1160.89 845.709 1164.19 845.119 1167.75 844.749L1175.88 843.959C1173.75 838.649 1167.72 826.369 1167.72 826.369Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1148.83 842.821C1146.48 844.321 1142.55 846.821 1141.18 847.821C1139.26 849.201 1138.52 847.731 1138.52 847.731C1138.48 848.073 1138.54 848.421 1138.69 848.732C1138.84 849.043 1139.08 849.303 1139.37 849.481C1139.63 849.625 1139.92 849.701 1140.22 849.701C1140.52 849.701 1140.81 849.625 1141.07 849.481L1151.45 843.831C1151.95 843.551 1152.5 843.382 1153.06 843.335C1153.63 843.288 1154.2 843.365 1154.73 843.561L1152.49 842.561C1151.91 842.309 1151.27 842.201 1150.63 842.246C1149.99 842.292 1149.38 842.489 1148.83 842.821Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    style: {
      baselineShift: 0,
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1140.7 846.349C1140.74 846.353 1140.78 846.347 1140.81 846.331C1140.85 846.315 1140.88 846.291 1140.91 846.259L1147.77 840.009C1147.9 839.849 1147.95 839.629 1147.77 839.499C1147.7 839.431 1147.61 839.393 1147.51 839.393C1147.41 839.393 1147.32 839.431 1147.25 839.499L1140.39 845.739C1140.32 845.809 1140.28 845.902 1140.28 845.999C1140.28 846.097 1140.32 846.19 1140.39 846.259C1140.48 846.318 1140.59 846.349 1140.7 846.349Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    style: {
      baselineShift: 0,
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1134.36 846.529C1134.43 846.529 1134.58 846.529 1134.57 846.439L1141.76 837.729C1141.79 837.692 1141.81 837.65 1141.83 837.604C1141.84 837.559 1141.85 837.511 1141.84 837.464C1141.84 837.416 1141.82 837.37 1141.8 837.328C1141.78 837.286 1141.75 837.249 1141.71 837.219C1141.67 837.189 1141.63 837.166 1141.59 837.152C1141.54 837.139 1141.49 837.134 1141.45 837.138C1141.4 837.143 1141.35 837.157 1141.31 837.179C1141.27 837.202 1141.23 837.232 1141.2 837.269L1134 845.999C1133.97 846.032 1133.94 846.071 1133.92 846.115C1133.9 846.159 1133.89 846.206 1133.89 846.254C1133.89 846.302 1133.9 846.349 1133.92 846.393C1133.94 846.437 1133.97 846.476 1134 846.509C1134.06 846.536 1134.12 846.552 1134.18 846.556C1134.24 846.559 1134.3 846.55 1134.36 846.529V846.529Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1204.82 754.879L1196.66 811.879L1162 824.999L1167 842.999L1198.4 840.999L1199.31 853.249L1210.51 852.939C1210.64 847.999 1211.82 808.249 1216.51 790.449L1231.07 788.559L1232.51 752.449L1204.82 754.879Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1131.57 664.891C1130.7 665.125 1129.91 665.568 1129.25 666.181C1128.59 666.806 1128.09 667.581 1127.79 668.441C1127.49 669.311 1127.41 670.24 1127.54 671.151C1127.67 672.057 1128.02 672.92 1128.54 673.671C1129.06 674.406 1129.74 675.006 1130.54 675.421C1131.34 675.821 1132.23 676.013 1133.13 675.98C1134.03 675.946 1134.9 675.689 1135.67 675.231C1136.45 674.765 1137.1 674.116 1137.56 673.341",
    stroke: "white",
    strokeWidth: 1.46,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    style: {
      baselineShift: 0,
      paintOrder: "normal",
      stroke: "rgb(255, 255, 255)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.46px",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1139.52 681.45C1141.85 683.43 1144.56 684.925 1147.48 685.848C1150.4 686.772 1153.47 687.106 1156.52 686.83L1158.28 686.68C1161.31 686.392 1164.24 685.487 1166.91 684.02C1169.61 682.559 1171.99 680.566 1173.91 678.16C1175.83 675.735 1177.27 672.961 1178.14 669.99C1178.99 666.993 1179.27 663.861 1178.96 660.76L1175.65 627.53C1175.44 625.445 1174.43 623.522 1172.83 622.17C1172.05 621.513 1171.14 621.018 1170.17 620.716C1169.19 620.414 1168.17 620.31 1167.15 620.41L1136.88 623.34C1135.57 623.48 1134.29 623.88 1133.14 624.517C1131.98 625.154 1130.96 626.015 1130.14 627.05C1128.46 629.184 1127.68 631.889 1127.96 634.59L1131.09 665.42C1131.74 671.647 1134.76 677.386 1139.52 681.45V681.45Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1210.5 853.5C1210.5 853.5 1218 877.07 1215.71 897.31C1213.77 914.51 1198.5 920.5 1180.62 920.31L1156.88 919.95L1083.5 902.5L1108.5 1009.5L1082.5 1016.5L1031.16 887.5C1029.64 883.746 1029.06 879.676 1029.49 875.647C1029.91 871.619 1031.31 867.756 1033.58 864.398C1035.84 861.04 1038.9 858.29 1042.47 856.39C1046.05 854.489 1050.04 853.497 1054.09 853.5H1210.5Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.37 653.689C1151.32 653.199 1151.41 652.703 1151.63 652.264C1151.85 651.824 1152.2 651.461 1152.63 651.218C1153.06 650.976 1153.55 650.866 1154.05 650.901C1154.54 650.936 1155.01 651.116 1155.4 651.418C1155.79 651.719 1156.08 652.129 1156.24 652.596C1156.4 653.063 1156.42 653.567 1156.29 654.044C1156.17 654.521 1155.9 654.95 1155.54 655.279C1155.17 655.607 1154.71 655.819 1154.22 655.889C1153.89 655.933 1153.55 655.91 1153.23 655.823C1152.91 655.736 1152.6 655.586 1152.34 655.381C1152.07 655.177 1151.85 654.922 1151.69 654.632C1151.52 654.341 1151.41 654.021 1151.37 653.689Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.2 653.87C1152.19 653.802 1152.19 653.732 1152.21 653.665C1152.22 653.597 1152.25 653.534 1152.29 653.478C1152.33 653.422 1152.38 653.375 1152.44 653.339C1152.5 653.303 1152.57 653.28 1152.64 653.27C1152.74 653.254 1152.85 653.268 1152.94 653.312C1153.04 653.356 1153.12 653.427 1153.17 653.517C1153.23 653.607 1153.26 653.711 1153.25 653.816C1153.25 653.921 1153.21 654.022 1153.15 654.107C1153.09 654.192 1153 654.256 1152.9 654.292C1152.8 654.328 1152.7 654.333 1152.6 654.308C1152.49 654.283 1152.4 654.227 1152.33 654.15C1152.26 654.072 1152.21 653.974 1152.2 653.87V653.87Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.05 656.461C1132 655.97 1132.09 655.475 1132.31 655.035C1132.53 654.596 1132.88 654.232 1133.31 653.99C1133.74 653.747 1134.23 653.637 1134.73 653.673C1135.22 653.708 1135.69 653.888 1136.08 654.189C1136.47 654.491 1136.76 654.901 1136.92 655.368C1137.08 655.835 1137.1 656.338 1136.97 656.815C1136.85 657.292 1136.58 657.722 1136.21 658.05C1135.85 658.378 1135.39 658.591 1134.9 658.661C1134.57 658.704 1134.23 658.682 1133.91 658.594C1133.59 658.507 1133.28 658.357 1133.02 658.153C1132.75 657.948 1132.53 657.694 1132.37 657.403C1132.2 657.113 1132.09 656.793 1132.05 656.461Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.87 656.521C1132.86 656.453 1132.86 656.383 1132.87 656.316C1132.89 656.248 1132.91 656.185 1132.95 656.128C1133 656.072 1133.05 656.025 1133.11 655.989C1133.16 655.954 1133.23 655.93 1133.3 655.921C1133.4 655.902 1133.51 655.914 1133.61 655.957C1133.7 655.999 1133.78 656.07 1133.84 656.159C1133.9 656.248 1133.93 656.352 1133.92 656.458C1133.92 656.563 1133.88 656.665 1133.82 656.751C1133.76 656.837 1133.68 656.902 1133.58 656.939C1133.48 656.976 1133.37 656.982 1133.27 656.957C1133.17 656.933 1133.07 656.878 1133 656.8C1132.93 656.722 1132.88 656.625 1132.87 656.521V656.521Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1179.84 657.869L1176.33 658.369L1181.26 665.009L1179.84 657.869Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    style: {
      baselineShift: 0,
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1142.86 664.831C1143 665.208 1143.22 665.55 1143.51 665.831C1143.79 666.118 1144.13 666.334 1144.51 666.461C1144.88 666.591 1145.27 666.639 1145.66 666.601L1149.02 666.451C1149.13 666.471 1149.23 666.471 1149.34 666.451C1149.44 666.421 1149.53 666.369 1149.6 666.301C1149.68 666.229 1149.74 666.144 1149.79 666.051C1149.83 665.949 1149.86 665.841 1149.86 665.731C1149.84 665.516 1149.75 665.314 1149.6 665.161C1149.52 665.092 1149.42 665.04 1149.32 665.011C1149.22 664.986 1149.11 664.986 1149.01 665.011L1145.65 665.161C1145.45 665.173 1145.26 665.139 1145.08 665.061C1144.89 664.992 1144.72 664.883 1144.57 664.741C1144.42 664.606 1144.3 664.439 1144.22 664.251C1144.14 664.064 1144.09 663.864 1144.08 663.661C1144.07 663.245 1144.22 662.842 1144.5 662.531C1144.75 662.226 1145.11 662.024 1145.5 661.961C1145.67 661.922 1145.81 661.827 1145.92 661.692C1146.02 661.557 1146.07 661.391 1146.07 661.221C1146.08 661.051 1146.02 660.885 1145.92 660.751C1145.82 660.612 1145.67 660.513 1145.5 660.471C1144.73 660.534 1144.01 660.892 1143.5 661.471C1142.96 662.078 1142.69 662.872 1142.73 663.681C1142.69 664.069 1142.73 664.462 1142.86 664.831V664.831Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1188 703L1215.73 705.77C1219.34 706.14 1222.75 707.591 1225.52 709.934C1228.29 712.277 1230.29 715.402 1231.25 718.9L1258.94 820.16C1259.44 821.989 1259.54 823.904 1259.22 825.774C1258.91 827.644 1258.19 829.423 1257.13 830.989C1256.06 832.554 1254.66 833.869 1253.03 834.841C1251.4 835.814 1249.59 836.421 1247.7 836.62L1167 846L1162.5 826.5L1222.5 809.5L1188 703Z",
    fill: "#3F4249",
    style: {
      baselineShift: 0,
      fill: "rgb(63, 66, 73)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1177.59 658.91C1177.59 658.91 1188.67 659.26 1190.34 647.91C1192.01 636.56 1178.34 635.21 1177.12 646.66L1176.38 659.13L1177.59 658.91Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1181.19 654.511C1182.18 654.479 1183.16 654.714 1184.02 655.191C1184.89 655.684 1185.61 656.394 1186.12 657.251C1186.63 658.119 1186.9 659.104 1186.92 660.111C1186.94 661.114 1186.69 662.105 1186.2 662.981C1185.73 663.843 1185.04 664.565 1184.2 665.071C1183.35 665.562 1182.39 665.814 1181.41 665.801C1180.42 665.777 1179.46 665.487 1178.62 664.961C1177.78 664.423 1177.09 663.68 1176.62 662.801",
    stroke: "white",
    strokeWidth: 1.46,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    style: {
      baselineShift: 0,
      paintOrder: "normal",
      stroke: "rgb(255, 255, 255)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.46px",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1187 643C1187.06 642.828 1187.06 642.641 1187 642.47C1186.94 642.303 1186.83 642.16 1186.68 642.06C1186.2 641.711 1185.64 641.469 1185.06 641.35C1184.48 641.23 1183.89 641.23 1183.31 641.35C1182.74 641.519 1182.22 641.817 1181.78 642.22C1181.35 642.626 1181.01 643.121 1180.78 643.67C1180.06 645.043 1179.73 646.591 1179.84 648.14V649.33C1179.84 650.19 1181.35 650.42 1181.29 649.33V648.03C1181.24 646.762 1181.5 645.5 1182.03 644.35C1182.19 643.979 1182.42 643.64 1182.7 643.35C1182.99 643.07 1183.33 642.849 1183.7 642.7C1184.51 642.57 1185.33 642.76 1186 643.23C1186.17 643.325 1186.36 643.353 1186.55 643.308C1186.73 643.264 1186.9 643.15 1187 642.99V643Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1164.92 646.15C1165.68 647.478 1166.12 648.963 1166.22 650.49C1166.27 651.218 1166.23 651.951 1166.11 652.67C1165.83 654.498 1165.04 656.209 1163.82 657.6C1162.62 658.971 1161.04 659.958 1159.28 660.44C1158.67 660.602 1158.05 660.689 1157.43 660.7C1156.18 660.77 1154.94 660.591 1153.76 660.174C1152.59 659.757 1151.51 659.11 1150.59 658.27C1148.7 656.547 1147.55 654.168 1147.36 651.62V651.46C1147.33 650.45 1147.44 649.44 1147.69 648.46C1146.12 648.159 1144.49 648.351 1143.04 649.01C1144.03 650.47 1144.61 652.169 1144.73 653.93C1144.9 656.475 1144.07 658.987 1142.42 660.93C1141.61 661.878 1140.63 662.656 1139.52 663.217C1138.41 663.779 1137.2 664.113 1135.96 664.2C1135.03 664.248 1134.1 664.15 1133.21 663.91C1131.25 663.395 1129.5 662.276 1128.21 660.71C1126.9 659.113 1126.12 657.15 1125.97 655.09C1125.79 652.545 1126.62 650.032 1128.28 648.091C1129.94 646.151 1132.29 644.937 1134.83 644.71C1135.82 644.678 1136.81 644.792 1137.77 645.05C1139.54 645.537 1141.14 646.523 1142.38 647.89C1144.16 646.962 1146.22 646.7 1148.18 647.15C1148.67 645.979 1149.38 644.916 1150.28 644.02C1151.17 643.151 1152.23 642.471 1153.4 642.02C1153.7 641.896 1154.01 641.789 1154.33 641.7C1154.95 641.551 1155.59 641.461 1156.23 641.43C1158.22 641.299 1160.19 641.822 1161.86 642.92C1163.11 643.745 1164.16 644.851 1164.92 646.15Z",
    stroke: "white",
    strokeWidth: 1.45,
    strokeMiterlimit: 10,
    style: {
      baselineShift: 0,
      paintOrder: "normal",
      stroke: "rgb(255, 255, 255)",
      strokeMiterlimit: 10,
      strokeWidth: "1.45px",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.4 670.999C1144.33 671.011 1144.26 671.038 1144.2 671.079C1144.15 671.131 1144.1 671.188 1144.06 671.249C1144.03 671.318 1144.01 671.393 1144.01 671.469C1144.01 671.545 1144.03 671.62 1144.06 671.689C1144.82 672.834 1145.88 673.745 1147.12 674.319C1148.35 674.886 1149.71 675.086 1151.05 674.895C1152.39 674.703 1153.64 674.128 1154.66 673.239C1155.69 672.337 1156.45 671.167 1156.85 669.859C1156.9 669.519 1156.76 669.229 1156.34 669.289L1144.4 670.999Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1177.89 632.28C1177.89 632.28 1184.18 605.38 1144.22 615.01C1121.22 620.56 1119.47 630.8 1118.85 636.09C1118.23 641.38 1130.85 632.47 1130.85 632.47C1130.85 632.47 1130.85 643.11 1135.06 640C1140.22 636.19 1146.17 627.76 1146.17 627.76C1146.17 627.76 1159.24 641.69 1172.32 638.6C1179.75 636.85 1177.89 632.28 1177.89 632.28Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1169.15 627.32C1169.15 627.32 1175.76 647.57 1176.01 651.61C1176.35 657.12 1184.31 638.61 1177.61 622.25L1169.15 627.32Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.36 856.08H1192V849H1047.36L1047.28 849.14C1046.71 850.207 1046.42 851.4 1046.43 852.61C1046.44 853.82 1046.76 855.007 1047.36 856.06V856.08Z",
    fill: "#21252B",
    style: {
      baselineShift: 0,
      fill: "rgb(33, 37, 43)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1047.36 856.08H1192V849H1047.36C1046.68 850.052 1046.32 851.278 1046.32 852.53C1046.32 853.783 1046.68 855.008 1047.36 856.06V856.08Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.04 849.17H1131.84L1100.25 786.26H1015.45L1047.04 849.17Z",
    fill: "#21252B",
    style: {
      baselineShift: 0,
      fill: "rgb(33, 37, 43)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1047.04 849.17H1131.84L1100.25 786.26H1015.45L1047.04 849.17Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1191.69 855.869H1133.35C1132.42 855.869 1131.52 855.497 1130.86 854.835C1130.19 854.173 1129.82 853.275 1129.82 852.339V852.339C1129.82 851.403 1130.19 850.505 1130.86 849.843C1131.52 849.181 1132.42 848.809 1133.35 848.809H1191.69V855.869Z",
    fill: "#21252B",
    style: {
      baselineShift: 0,
      fill: "rgb(33, 37, 43)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1131.46 849.94L1134.23 848.81L1102.64 786.26H1099.48L1131.46 849.94Z",
    fill: "#21252B",
    style: {
      baselineShift: 0,
      fill: "rgb(33, 37, 43)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1075.49 825.181C1077.75 823.135 1077.26 818.921 1074.41 815.768C1071.56 812.616 1067.41 811.719 1065.15 813.766C1062.89 815.812 1063.37 820.026 1066.23 823.179C1069.08 826.331 1073.23 827.228 1075.49 825.181Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1130.97 848.95L1047.24 849L1046.78 848.1H1130.54L1130.97 848.95Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1192.32 905.361C1189.67 907.65 1186.57 909.365 1183.23 910.397C1179.88 911.43 1176.36 911.758 1172.88 911.361L1076 899.001L1083.56 902.761L1083.5 902.501L1156.88 920.001L1180.62 920.361C1198.5 920.541 1213.77 914.551 1215.71 897.361C1218 877.121 1210.5 853.551 1210.5 853.551H1197.25C1197.25 853.551 1210.71 889.001 1192.32 905.361Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1076 899L1101.84 1010.75L1109 1009L1083 902L1076 899Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066.62 1036.79L1060.46 1041.94C1058.24 1043.76 1056.65 1046.23 1055.92 1049C1055.32 1051.42 1055.58 1053.71 1059.05 1053.14L1109.8 1034.65C1110.74 1034.32 1111.61 1033.8 1112.34 1033.11C1113.07 1032.43 1113.64 1031.6 1114.03 1030.68C1114.42 1029.76 1114.62 1028.77 1114.6 1027.77C1114.58 1026.77 1114.35 1025.79 1113.93 1024.88C1112.78 1022.52 1111.4 1020.28 1109.8 1018.19C1109.16 1017.34 1108.65 1016.42 1108.26 1015.43V1015.43C1071.49 1043.84 1066.62 1036.79 1066.62 1036.79Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1056.2 1052.53C1056.7 1053.11 1057.59 1053.38 1059.05 1053.14L1109.8 1034.65C1110.88 1034.27 1111.86 1033.63 1112.65 1032.79C1113.44 1031.95 1114.01 1030.93 1114.33 1029.82L1056.2 1052.53Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1247.7 836.62C1249.59 836.42 1251.4 835.813 1253.03 834.841C1254.66 833.868 1256.06 832.554 1257.13 830.988C1258.19 829.423 1258.91 827.643 1259.22 825.773C1259.54 823.904 1259.44 821.988 1258.94 820.159L1256.38 810.77C1255.75 828.55 1242 829 1242 829L1166 841.84L1167 846L1247.7 836.62Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.28 782.039L1149.03 780.899L1146.81 782.109L1147.2 779.609L1145.37 777.879L1147.86 777.479L1148.94 775.199L1150.09 777.449L1152.6 777.769L1150.82 779.559L1151.28 782.039Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1190.28 779.039L1188.03 777.899L1185.81 779.109L1186.2 776.609L1184.37 774.879L1186.86 774.479L1187.94 772.199L1189.09 774.449L1191.6 774.769L1189.82 776.559L1190.28 779.039Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1174.28 814.039L1172.03 812.899L1169.81 814.109L1170.2 811.609L1168.37 809.879L1170.86 809.479L1171.94 807.199L1173.09 809.449L1175.6 809.769L1173.82 811.559L1174.28 814.039Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1220.28 821.039L1218.03 819.899L1215.81 821.109L1216.2 818.609L1214.37 816.879L1216.86 816.479L1217.94 814.199L1219.09 816.449L1221.6 816.769L1219.82 818.559L1220.28 821.039Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1181.28 843.039L1179.03 841.899L1176.81 843.109L1177.2 840.609L1175.37 838.879L1177.86 838.479L1178.94 836.199L1180.09 838.449L1182.6 838.769L1180.82 840.559L1181.28 843.039Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1095.28 781.039L1093.03 779.899L1090.81 781.109L1091.2 778.609L1089.37 776.879L1091.86 776.479L1092.94 774.199L1094.09 776.449L1096.6 776.769L1094.82 778.559L1095.28 781.039Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1129.28 814.039L1127.03 812.899L1124.81 814.109L1125.2 811.609L1123.37 809.879L1125.86 809.479L1126.94 807.199L1128.09 809.449L1130.6 809.769L1128.82 811.559L1129.28 814.039Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213.86 801.48L1211.37 801.88L1213.2 803.61L1212.81 806.11L1213.81 805.57C1214.06 803.57 1214.33 801.72 1214.61 799.91L1213.86 801.48Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1206.28 750.039L1204.03 748.899L1201.81 750.109L1202.2 747.609L1200.37 745.879L1202.86 745.479L1203.94 743.199L1205.09 745.449L1207.6 745.769L1205.82 747.559L1206.28 750.039Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1242.28 779.039L1240.03 777.899L1237.81 779.109L1238.2 776.609L1236.37 774.879L1238.86 774.479L1239.94 772.199L1241.09 774.449L1243.6 774.769L1241.82 776.559L1242.28 779.039Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.28 714.039L1197.03 712.899L1194.81 714.109L1195.2 711.609L1193.37 709.879L1195.86 709.479L1196.94 707.199L1198.09 709.449L1200.6 709.769L1198.82 711.559L1199.28 714.039Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1157.28 747.039L1155.03 745.899L1152.81 747.109L1153.2 744.609L1151.37 742.879L1153.86 742.479L1154.94 740.199L1156.09 742.449L1158.6 742.769L1156.82 744.559L1157.28 747.039Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1129.28 724.039L1127.03 722.899L1124.81 724.109L1125.2 721.609L1123.37 719.879L1125.86 719.479L1126.94 717.199L1128.09 719.449L1130.6 719.769L1128.82 721.559L1129.28 724.039Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1127.28 763.039L1125.03 761.899L1122.81 763.109L1123.2 760.609L1121.37 758.879L1123.86 758.479L1124.94 756.199L1126.09 758.449L1128.6 758.769L1126.82 760.559L1127.28 763.039Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1235 621.58C1235 609.02 1249.1 598.83 1266.5 598.83C1283.9 598.83 1298 609 1298 621.58C1298 634.16 1283.9 644.33 1266.5 644.33C1264.28 644.33 1262.06 644.159 1259.86 643.82L1244.33 649L1247.67 639.82C1240 635.67 1235 629.05 1235 621.58Z",
    fill: "#B2B6BB",
    style: {
      baselineShift: 0,
      fill: "rgb(178, 182, 187)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1278.17 625.67C1280.1 625.67 1281.67 624.103 1281.67 622.17C1281.67 620.237 1280.1 618.67 1278.17 618.67C1276.24 618.67 1274.67 620.237 1274.67 622.17C1274.67 624.103 1276.24 625.67 1278.17 625.67Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1266.5 625.67C1268.43 625.67 1270 624.103 1270 622.17C1270 620.237 1268.43 618.67 1266.5 618.67C1264.57 618.67 1263 620.237 1263 622.17C1263 624.103 1264.57 625.67 1266.5 625.67Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.83 625.67C1256.76 625.67 1258.33 624.103 1258.33 622.17C1258.33 620.237 1256.76 618.67 1254.83 618.67C1252.9 618.67 1251.33 620.237 1251.33 622.17C1251.33 624.103 1252.9 625.67 1254.83 625.67Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglishCourse);
export default __webpack_public_path__ + "static/media/english-course.73e4b4e9cf6d6010fa055cff9a66e470.svg";
export { ForwardRef as ReactComponent };